<template>
     <div id="main-content">
        <div class="top-block phone-no-border">
            <div class="selected-item">
                <div>
                    <span class="title">Настройки аккаунта</span>
                </div>
                <user-info></user-info>
            </div>
        </div>
        <div class="general-form">
            <div class="info">
                Daichi Comfort - автоматическая система управления климатическим
                оборудованием компании Даичи при помощи мобильных устройств из
                любой точки мира. Она позволяет контролировать и изменять микроклимат
                в своем доме или офисе и обеспечивать оптимальный комфорт. С помощью
                Daichi Comfort управление микроклиматом становится простым, интуитивно
                понятным, интеллектуальным и энергоэффективным.
                <br>
                <br>
                <a href="/docs/terms.pdf" target="_blank">Лицезионное соглашение</a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .info{
        font-weight: 400;
        line-height: 20px;
        font-size: 16px;
        padding: 40px 30px;
        max-width: 700px;
        text-align: justify;

        a{
            color: #5EA9FF;
            &:hover{
                color: #4B87CC;
            }
        }
    }
</style>

<script>
    import userInfo from '../other/topUserInfo'

    export default {
        components:{
            userInfo,
        },
        data() {
            return { }
        }
    }
</script>
